<template>
    <div class="pt-4">
        <a class="arm-button" :href="lienRetourSite" target="_self"> 
            <text  v-if="!envARLDE" >Retour au site</text>
            <text  v-if="envARLDE" >Zurück zur Website</text>
        </a>
    </div>
</template>

<script>
export default {
    name: 'ButtonReturnSite',
    props: {
        lienRetourSite: String,
        envARLDE: Boolean
    }
}
</script>

<style>

.arm-button {
    transition: all .3s cubic-bezier(0.52, 0.12, 0.05, 0.95);
    background-color: var(--color-heading);
    color: #fff;
    text-transform: uppercase;
    font-family: "CabinetGrotesk-Bold", sans-serif;
    border-radius: 45px;
    box-shadow: none;
    padding: 8px 45px;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 500;
    line-height: 25px;
    border: 1px solid transparent;
    cursor: pointer;
    position: relative;
}

.arm-button:hover {
    background-color: var(--vt-c-gris);
    color: var(--vt-c-background-color);
}

a.arm-button:hover {
    text-decoration: none;
}

</style>